// extracted by mini-css-extract-plugin
module.exports = {"error":"errors_error__3R3UW"};